<template>
    <div class="container">
        <div id="overlay_forms" v-if="loading">
            <div class="w-100 d-flex justify-content-center align-items-center">
                <p>Loading... page may take several moments to load</p>
                <div class="spinner"></div>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-md-12 mb-5">
                <h1 class="sb-main-header">{{ title() }}</h1>
            </div>
        </div>

        <div v-if="formName === 'Change of Address'" class="col-md-12">
            <p class="mb-1">
                Submit any change in your address using the form below.
                Address changes may take up to 10 days to be fully processed.
            </p>
        </div>

        <div class="card brd-primary">
            <div class="card-body">
                <div class="row justify-content-center">
                    <div class="col-md-12">
                        <form id="form">
                            <table class="table table-striped tbl-form table-bordered" id="sbforms_questions">
                                <tbody>
                                <tr v-for="(qwst, index) in questions" v-if="canBeShown(qwst)" :key="index">
                                    <template v-if="index > 0">
                                        <th scope="row" :id="qwst.id">
                                            <input type="hidden" name="form_id" :value="qwst.form_id" v-if="!index">
                                            <div v-if="showTextInput(qwst)" class="form-group row div-zebra">
                                                <label :for="'qwst_'+qwst.id"
                                                       :class="getRequiredLabelClass(qwst.required)">{{ qwst.question }}</label>
                                                <div class="col-md-4">
                                                    <p v-if="isReadOnly(qwst.readonly)" class="pt-2 mb-0">{{qwst.value}}</p>
                                                    <input v-else type="text" class="form-control"
                                                           v-mask="getMask(qwst)"
                                                           :data-validation="qwst.validation" :id="'qwst_'+qwst.id"
                                                           :name="'qwst_'+qwst.id" :readonly="isReadOnly(qwst.readonly)"
                                                           :required="isRequired(qwst.required)" v-model="qwst.value" :maxlength="findMaxLength(qwst)">
                                                </div>
                                            </div>

                                            <div v-if="showTextMaskInput(qwst)" class="form-group row div-zebra">
                                                <label :for="'qwst_'+qwst.id"
                                                       :class="getRequiredLabelClass(qwst.required, qwst.validation)">{{ qwst.question }}</label>
                                                <div class="col-md-4">
                                                    <input type="text"
                                                           v-mask="getMask(qwst)"
                                                           :data-validation="qwst.validation" class="form-control"
                                                           :id="'qwst_'+qwst.id" :name="'qwst_'+qwst.id"
                                                           :required="isRequired(qwst.required)" v-model="qwst.value"
                                                           :placeholder="qwst.mask === 'date' ? 'mm/dd/yyyy' : ''">
                                                </div>
                                            </div>

                                            <div v-if="showSingleSelect(qwst)" class="form-group row div-zebra">
                                                <label :for="'qwst_'+qwst.id"
                                                       :class="getRequiredLabelClass(qwst.required)">{{ qwst.question }}</label>
                                                <div class="col-md-4">
                                                    <select class="form-control" :name="'qwst_'+qwst.id"
                                                            :id="'qwst_'+qwst.id" :required="isRequired(qwst.required)"
                                                            v-model="qwst.value" :data-validation="qwst.validation">
                                                        <option value="">Please Select</option>
                                                        <option v-for="t in qwst.choices.split('|')" :value="t">
                                                            {{ t }}
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>

                                            <div v-if="showCheckboxInput(qwst)" class="form-group row div-zebra">
                                                <p :class="getRequiredLabelClass(qwst.required)">
                                                    {{ showMainLabel(qwst) }}</p>
                                                <div class="col-md-4">
                                                    <div class="form-check" v-if="showCheckboxInput(qwst)"
                                                         v-for="ch in getSource(qwst)">
                                                        <input class="form-check-input" type="checkbox"
                                                               :name="getName(qwst)" value="Yes" :id="'id'+ch"
                                                               :data-validation="qwst.validation"
                                                               :required="isRequired(qwst.required)"
                                                               @click='deRequire(qwst)' v-model="qwst.value">
                                                        <label class="form-check-label"
                                                               :for="'id'+ch">{{ getLabel(qwst, ch, qwst.question) }}</label>
                                                    </div>
                                                </div>
                                            </div>

                                            <div v-if="showNumberInput(qwst)" class="form-group row div-zebra">
                                                <label :for="'qwst_'+qwst.id"
                                                       :class="getRequiredLabelClass(qwst.required)">{{ qwst.question }}</label>
                                                <div class="col-md-4">
                                                    <input type="number" :id="'qwst_'+qwst.id" class="form-control"
                                                           v-mask="getMask(qwst)"
                                                           :name="'qwst_'+qwst.id" :required="isRequired(qwst.required)"
                                                           :data-validation="qwst.validation"
                                                           v-model="qwst.value">
                                                </div>
                                            </div>

                                            <div v-if="showCurrencyInput(qwst)" class="form-group row div-zebra">
                                                <label :for="'qwst_'+qwst.id"
                                                       :class="getRequiredLabelClass(qwst.required)">{{ qwst.question }}</label>
                                                <div class="col-md-4">
                                                    <input type="text" :id="'qwst_'+qwst.id" class="form-control"
                                                           :name="'qwst_'+qwst.id" :required="isRequired(qwst.required)"
                                                           :data-validation="qwst.validation"
                                                           v-model="qwst.value" v-mask="currencyMask">
                                                </div>
                                            </div>

                                            <div v-if="showTextareaInput(qwst)" class="form-group row div-zebra">
                                                <label :for="'qwst_'+qwst.id"
                                                       :class="getRequiredLabelClass(qwst.required)">{{ qwst.question }}</label>
                                                <div class="col-md-4">
                                                    <textarea class="form-control" :id="'qwst_'+qwst.id"
                                                              :name="'qwst_'+qwst.id"
                                                              :readonly="isReadOnly(qwst.readonly)"
                                                              :required="isRequired(qwst.required)"
                                                              :data-validation="qwst.validation"
                                                              v-model="qwst.value">{{getDefaultValue(qwst)}}</textarea>
                                                </div>
                                            </div>
                                        </th>
                                    </template>
                                    <template v-else>
                                        <th scope="row" :id="qwst.id">
                                            <input type="hidden" name="form_id" :value="qwst.form_id" v-if="!index">
                                            <div v-if="showTextInput(qwst)" class="form-group row div-zebra">
                                                <label :for="'qwst_'+qwst.id"
                                                       :class="getRequiredLabelClass(qwst.required)">{{ qwst.question }}</label>
                                                <div class="col-md-4">
                                                    <p v-if="isReadOnly(qwst.readonly)" class="pt-2 mb-0">{{qwst.value}}</p>
                                                    <input v-else type="text" class="form-control" :id="'qwst_'+qwst.id"
                                                           v-mask="getMask(qwst)"
                                                           :name="'qwst_'+qwst.id" :readonly="isReadOnly(qwst.readonly)"
                                                           :data-validation="qwst.validation"
                                                           :required="isRequired(qwst.required)" v-model="qwst.value" :maxlength="findMaxLength(qwst)">
                                                </div>
                                            </div>

                                            <div v-if="showTextMaskInput(qwst) && qwst.question === 'Date of birth'" class="form-group row div-zebra">
                                                <label :for="'qwst_'+qwst.id"
                                                       :class="getRequiredLabelClass(qwst.required)">{{ qwst.question }}</label>
                                                <div class="col-md-4">
                                                    <input type="text" v-mask="getMask(qwst)" class="form-control"
                                                           :id="'qwst_'+qwst.id" :name="'qwst_'+qwst.id"
                                                           :required="isRequired(qwst.required)" v-model="qwst.value"
                                                           :data-validation="'date_between:1900-01-01:' + today()"
                                                           :placeholder="qwst.mask === 'date' ? 'mm/dd/yyyy' : ''">
                                                </div>
                                            </div>

                                            <div v-else-if="showTextMaskInput(qwst)" class="form-group row div-zebra">
                                                <label :for="'qwst_'+qwst.id"
                                                       :class="getRequiredLabelClass(qwst.required)">{{ qwst.question }}</label>
                                                <div class="col-md-4">
                                                    <input type="text" v-mask="getMask(qwst)" class="form-control"
                                                           :id="'qwst_'+qwst.id" :name="'qwst_'+qwst.id"
                                                           :required="isRequired(qwst.required)" v-model="qwst.value"
                                                           :data-validation="qwst.validation"
                                                           :placeholder="qwst.mask === 'date' ? 'mm/dd/yyyy' : ''">
                                                </div>
                                            </div>

                                            <div v-if="showSingleSelect(qwst)" class="form-group row div-zebra">
                                                <label :for="'qwst_'+qwst.id"
                                                       :class="getRequiredLabelClass(qwst.required)">{{ qwst.question }}</label>
                                                <div class="col-md-4">
                                                    <select :disabled="disableSelect"
                                                            :style="disableSelect ? 'cursor: not-allowed;' : ''"
                                                            class="form-control coverage-select"
                                                            :name="'qwst_'+qwst.id"
                                                            :id="'qwst_'+qwst.id" :required="isRequired(qwst.required)"
                                                            :data-validation="qwst.validation"
                                                            v-model="qwst.value">
                                                        <option value="">Please Select</option>
                                                        <option v-for="t in qwst.choices.split('|')" :value="t">
                                                            {{ optionValue(t) }}
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>

                                            <div v-if="showCheckboxInput(qwst)" class="form-group row div-zebra">
                                                <p :class="getRequiredLabelClass(qwst.required)">
                                                    {{ showMainLabel(qwst) }}</p>
                                                <div class="col-md-4">
                                                    <div class="form-check" v-if="showCheckboxInput(qwst)"
                                                         v-for="ch in getSource(qwst)">
                                                        <input class="form-check-input" type="checkbox"
                                                               :name="getName(qwst)" value="Yes" :id="'id'+ch"
                                                               :required="isRequired(qwst.required)"
                                                               :data-validation="qwst.validation"
                                                               @click='deRequire(qwst)' v-model="qwst.value">
                                                        <label class="form-check-label"
                                                               :for="'id'+ch">{{ getLabel(qwst, ch, qwst.question) }}</label>
                                                    </div>
                                                </div>
                                            </div>

                                            <div v-if="showNumberInput(qwst)" class="form-group row div-zebra">
                                                <label :for="'qwst_'+qwst.id"
                                                       :class="getRequiredLabelClass(qwst.required)">{{ qwst.question }}</label>
                                                <div class="col-md-4">
                                                    <input type="number" :id="'qwst_'+qwst.id" class="form-control"
                                                           v-mask="getMask(qwst)"
                                                           :name="'qwst_'+qwst.id" :required="isRequired(qwst.required)"
                                                           :data-validation="qwst.validation"
                                                           v-model="qwst.value">
                                                </div>
                                            </div>

                                            <div v-if="showCurrencyInput(qwst)" class="form-group row div-zebra">
                                                <label :for="'qwst_'+qwst.id"
                                                       :class="getRequiredLabelClass(qwst.required)">{{ qwst.question }}</label>
                                                <div class="col-md-4">
                                                    <input type="text" :id="'qwst_'+qwst.id" class="form-control"
                                                           :name="'qwst_'+qwst.id" :required="isRequired(qwst.required)"
                                                           :data-validation="qwst.validation"
                                                           v-model="qwst.value" v-mask="currencyMask">
                                                </div>
                                            </div>

                                            <div v-if="showTextareaInput(qwst)" class="form-group row div-zebra">
                                                <label :for="'qwst_'+qwst.id"
                                                       :class="getRequiredLabelClass(qwst.required)">{{ qwst.question }}</label>
                                                <div class="col-md-4">
                                                    <textarea class="form-control" :id="'qwst_'+qwst.id"
                                                              :name="'qwst_'+qwst.id"
                                                              :readonly="isReadOnly(qwst.readonly)"
                                                              :required="isRequired(qwst.required)"
                                                              :data-validation="qwst.validation"
                                                              v-model="qwst.value">{{getDefaultValue(qwst)}}</textarea>
                                                </div>
                                            </div>
                                        </th>
                                    </template>
                                </tr>
                                </tbody>
                            </table>

                            <div class="row">
                                <div class="col-sm-12">

                                    <button type="button" class="btn btn-primary float-right" @click="submitForm"
                                            :disabled='isDisabled'>Submit
                                    </button>
                                    <label class="float-right mr-3 mt-2">Click Submit to Submit Request</label>
                                </div>
                            </div>

                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import createNumberMask from 'text-mask-addons/dist/createNumberMask'
const currencyMask = createNumberMask({
    prefix: '$',
    allowDecimal: true,
    includeThousandsSeparator: true,
    thousandsSeparatorSymbol:',',
    allowNegative: false,
});
const ssnMask = createNumberMask({
    prefix: '',
    includeThousandsSeparator: false,
    integerLimit: 4,
    allowLeadingZeroes: true,
});
export default {
    props: ['formName', 'user', 'plans'],

    mounted() {
        this.getQuestions();
    },
    data() {
        return {
            route: '/api/form/response',
            //u:this.user,
            loading:true,
            questions: [],
            myInputModel: '',
            ch_source: [],
            isDisabled: true,
            ssnMask,
            currencyMask,
            disableSelect:false,
            questionInQuestion: '',
            isIdMatched: '',
            otherQuestionId: '',
        }
    },
    computed: {
        shownQuestions() {
            const shownQuestions = [];
            this.questions.forEach((question) => {
                if (this.canBeShown(question)) {
                    shownQuestions.push(question);
                }
            });
            return shownQuestions;
        },
    },
    methods: {
        today() {
            return moment().format('MM/DD/YYYY');
        },
        canBeShown(question, visited = new Set()) {
            if (question.parent_id && question.parent_value) {
                const parent = _.find(this.questions, {id: question.parent_id})
                return parent.value == question.parent_value && this.canBeShown(parent);
            } else {
                return true;
            }
        },
        showMainLabel(question) {
            if (question.choices == '1') {
                return '';
            } else {
                return question.question;
            }
        },
        getSource(qwst) {
            if (qwst.source) {
                var tname = qwst.source;
                return this[tname];
            } else {
                return qwst.choices.split('|');
            }

        },
        showTextMaskInput(qwst) {
            return qwst.type_name === "Single Textbox" && qwst.mask;
        },

        getDefaultValue(qwst) {
            if (qwst.source) {
                var tname = qwst.source;
                var arr = tname.split('.');
                return this[arr[0]][arr[1]]; //this.{$tname};
            }
        },

        findMaxLength(qwst) {
            if (qwst.validation) {
                const validations = qwst.validation.split('|')
                const lengthValidation = validations.find(v => v.startsWith('length:'))
                if (lengthValidation) {
                    const validationArr = lengthValidation.split(':')
                    switch (validationArr.length) {
                        case 2:
                            return validationArr[1]
                        case 3:
                            return validationArr[2]
                        default:
                            return -1
                    }
                }
            }

            return -1
        },

        getMask(qwst) {
            switch (qwst.mask) {
                case 'currency':
                    return this.currencyMask
                case 'ssn':
                    return this.ssnMask
                case 'date':
                    return '##/##/####'
            }

            return ''
        },

        deRequire(qwst_) {
            //var el=document.getElementsByName(qwst);
            var qwst = this.getName(qwst_)
            var atLeastOneChecked = false;//at least one cb is checked
            $('[name="' + qwst + '"]').each(function () {
                if (this.checked) {
                    atLeastOneChecked = true;
                    return false; // breaks
                }
            });

            if (atLeastOneChecked === true) {
                $('[name="' + qwst + '"]').each(function () {
                    $(this).prop('required', false);
                });
            } else {
                $('[name="' + qwst + '"]').each(function () {
                    $(this).prop('required', true);
                });
            }
        },

        getLabel(qwst, ch, question) {
            var choices = this.getSource(qwst);
            if (Object.keys(choices).length > 1 || qwst.source) {
                return ch;
            } else {
                return question;
            }
        },

        getName(qwst) {
            var choices = this.getSource(qwst);
            if (Object.keys(choices).length > 1) {
                return 'qwst_' + qwst.id; //+'[]';
            } else {
                return 'qwst_' + qwst.id;
            }

        },

        getOptions(str) {
            return str.join('|');
        },

        isRequired(required) {
            if (required == 1) {
                return "required";

            } else {
                return false;
            }
        },

        getRequiredLabelClass(required, validation = false) {
            if (required == 1) {
                return 'col-sm-6 col-form-label required';
            } else {
                if (validation && (validation.includes("required_if") || validation.includes("required_without"))) {
                    const regex = /qwst_(\d+)/;
                    const match = validation.match(regex);
                    if (match && match[1]) {
                        const otherQuestionId = parseInt(match[1], 10);
                        const otherQuestionIsShown = this.shownQuestions.some((question) => question.id === otherQuestionId);
                        if((otherQuestionIsShown && validation.includes("required_if")) || (!otherQuestionIsShown && validation.includes("required_without"))) {
                            return 'col-sm-6 col-form-label required';
                        } else {
                            return 'col-sm-6 col-form-label';
                        }
                    }
                }
                return 'col-sm-6 col-form-label';
            }
        },


        isReadOnly(readonly) {
            return readonly == 1;
        },
        showTextInput(qwst) {
            return qwst.type_name === "Single Textbox" && !qwst.mask;
        },
        showCheckboxInput(qwst) {
            return qwst.type_name === "Checkbox Selection";
        },
        showSingleSelect(qwst) {
            return qwst.type_name === "Single Selection";
        },
        showNumberInput(qwst) {
            return qwst.type_name === "Number";
        },
        showCurrencyInput(qwst) {
            return qwst.type_name === "Currency";
        },
        showTextareaInput(qwst) {
            return qwst.type_name === "textarea";
        },


        getQuestions() {
            // window.location.href
            this.$http.get("/api/questions?form=" + this.formName)
                .then(function (response) {
                    const questions = response.body;
                    questions.forEach((value, key) => {
                        questions[key]['value'] = this.getDefaultValue(value);
                        if (questions[key]['type_name'] === 'Checkbox Selection' && questions[key]['value'] == undefined)
                            questions[key]['value'] = [];

                        if(value.type_id === 1) {
                            const choices = value.choices.split("|");
                            if (choices.length === 1) {
                                //this is here for when a single select question only has one answer.  it will default to the only choice.
                                value.value = choices[0];
                                this.disableSelect = true;
                            }
                        }
                    })
                    this.questions = questions;
                    this.isDisabled=false;
                    this.loading=false;
                });
        },
        submitForm() {
            let myForm = document.getElementById('form');
            //var valid =  myForm[0].checkValidity();
            var valid = $('#form')[0].checkValidity();

            console.log(valid)

            if (!valid) {
                //myForm.reportValidity();
                $('#form')[0].reportValidity();
                return false;
            }

            const customValid = this.checkCustomValidation($('#form'));

            console.log(customValid)

            if (customValid !== 0) return false;

            this.isDisabled = true;
            let formData = new FormData(myForm);

            var object = {};
            formData.forEach((value, key) => {
                // Reflect.has in favor of: object.hasOwnProperty(key)
                if (!Reflect.has(object, key)) {
                    object[key] = value;
                    return;
                }
                if (!Array.isArray(object[key])) {
                    object[key] = [object[key]];
                }
                object[key].push(value);
            });
            // var data = JSON.stringify(object);

            /*
            const data = {};
            // need to convert it before using not with XMLHttpRequest
            for (let [key, val] of formData.getAll()) {
                Object.assign(data, {[key]: val})
            }

            */

            console.log(object);

            document.getElementById("overlay").style.display = "flex";
            this.$http.post(this.route, object)
                .then(function (response) {

                    $('.has-error').removeClass('has-error')
                    $('.help-block').remove()
                    this.showModal = false;
                    window.location.href = '/forms/confirmation/' + this.formName;

                }, (response) => {
                    this._handleErrors(response.data, '#form')
                    this.isDisabled = false;
                    console.log(response);
                    document.getElementById("overlay").style.display = "none";
                })
        },

        checkCustomValidation(form) {
            const errors = [];
            $('.has-error').removeClass('has-error')
            $('.help-block').remove()
            form.find('input').each((index, inp) => {
                if ($(inp).data('validation')) {
                    let validation = $(inp).data('validation');
                    let validations
                    if (validation)
                        validations = validation.split('|')

                    validations.forEach(v => {
                        let validationArr = v.split(':');
                        let error='';
                        switch (validationArr[0]) {
                            case 'today':
                                if ($(inp).val() && $(inp).val() !== this.today()){
                                    errors.push('Today\'s date is not correct')
                                    error='Today\'s date is not correct';
                                }
                                break
                            case 'required_without':
                                if (!$(inp).val() && !this.checkRequiredField(form, validationArr[1])){
                                    errors.push('Please fill out one of required fields');
                                    error='Please fill out one of the required fields for current or spouse coverage'; //TODO: remove that hardcode
                                }
                                break
                            case 'required_if':
                                if (!$(inp).val() && this.checkRequiredField(form, validationArr[1])){
                                    errors.push('Please fill out one of required fields')
                                    error='Please fill out one of required fields';
                                }
                                break
                            case 'required':
                                if (!$(inp).val()){
                                    errors.push('Please fill out this field')
                                    error='Please fill out this field';
                                }
                                break
                            case 'numeric':
                                if ($(inp).val() && !isFinite($(inp).val().replace("$", "").replaceAll(",", ""))){
                                    errors.push('This field should be numeric')
                                    error='This field should be numeric';
                                }
                                break
                            case 'integer':
                                if ($(inp).val() && !(/^\d+$/.test($(inp).val()))){
                                    errors.push('This field should be numeric')
                                    error='This field should be numeric';
                                }
                                break
                            case 'length':
                                const symbName = validations.includes('numeric') || validations.includes('integer') ? 'numbers' : 'symbols'
                                if ($(inp).val() && validationArr.length === 2 && $(inp).val().length != validationArr[1]){
                                    errors.push(`This field should be exactly ${validationArr[1]} ${symbName} in length`)
                                    error=`This field should be exactly ${validationArr[1]} ${symbName} in length`;
                                }
                                else if ($(inp).val() && validationArr.length === 3 && ($(inp).val().length < validationArr[1] || $(inp).val().length > validationArr[2])){
                                    errors.push(`This field should be between ${validationArr[1]} and ${validationArr[2]} symbols in length`)
                                    error=`This field should be between ${validationArr[1]} and ${validationArr[2]} symbols in length`;
                                }
                                break
                            case 'date_between':
                                // check for valid input date:

                                let dateValidation = moment($(inp).val()).isValid();

                                if (dateValidation === false) {
                                    error = 'Please enter a valid date.';
                                    errors.push(error);
                                }

                                // check for valid date parameters (min/max):

                                if ($(inp).val() && (moment($(inp).val()).isBefore(validationArr[1] === 'today' ? undefined : validationArr[1]) || moment($(inp).val()).isAfter(validationArr[2] === 'today' ? undefined : validationArr[2]))){
                                    errors.push(`This date should be between ${moment(validationArr[1]).format('MM/DD/YYYY')} and ${validationArr[2]}`)
                                    error=`This date should be between ${moment(validationArr[1]).format('MM/DD/YYYY')} and ${validationArr[2]}`;
                                }
                                break
                        }
                        if(error!=''){
                            let el = $(inp)
                            el.closest('.form-group').addClass('has-error')
                            $('<p class="help-block">' + error + '</p>').insertAfter(el);

                        }
                    })

                }
            })
            return errors.length;
        },

        checkRequiredField(form, field) {
            const formField = form.find(`input[name=${field}]`)
            return !!$(formField).val()
        },

        _handleErrors: function (items, selector) {
            $('.has-error').removeClass('has-error')
            $('.help-block').remove()

            for (var error in items['errors']) {
                if (items['errors'].hasOwnProperty(error)) {
                    var text = error;
                    var parts = text.split('.');
                    var name = parts.pop();
                    var el = $(selector + ' [name="' + name + '"]')
                    el.closest('.form-group').addClass('has-error')
                    $('<p class="help-block">' + (items['errors'][error].join(', ')) + '</p>').insertAfter(selector + ' [name="' + name + '"]');
                }
            }
        },
        optionValue(value) {
            return {
                'Group Term Life Insurance': 'Group Term Life (G-29297-1)',
                'UBLIC': 'UBLIC (G-29297-0)'
            }[value] || value;
        },
        title() {
            return this.formName === "Coverage" ? "Decrease or Cancel " + this.formName : this.formName + " Form";
        }
    }
}
</script>
